import {FC, PropsWithChildren, useMemo, useState} from "react";
import {CreatePlan} from "../view-model";
import {PlanController} from "./PlanController";
import {PlanContext} from "./PlanContext";

export interface PlanProviderProps {
  /**
   * The initial plan to build upon
   */
  initial: CreatePlan;
}

export const PlanProvider: FC<PropsWithChildren<PlanProviderProps>> = ({
  initial,
  children
}) => {
  const [plan, setPlan] = useState<CreatePlan>(initial);

  const controller = useMemo<PlanController>(
    () => ({
      plan
    }),
    [plan]
  );

  return (
    <PlanContext.Provider value={controller}>{children}</PlanContext.Provider>
  );
};
